import { FilterableColumn } from "./table-filter-select";

// Note: this class won't be used directly by external consumers.
/** ###Do Not Display### */
export class TableFilterGroupBinding {
  /** Collection of filterable columns that should be rendered in the table filter group. */
  public filterableColumns = "<";
}

export class TableFilterGroupController {
  public filterableColumns: FilterableColumn[];
}
export const sdTableFilterGroup: ng.IComponentOptions = {
  bindings: <any>new TableFilterGroupBinding(),
  controller: TableFilterGroupController,
  templateUrl: "../ShellCommon/Controls/table/table-filter-group.html"
};
